import React from "react";
import ReactDOM from "react-dom/client"; // Use 'react-dom/client' instead of 'react-dom'
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ImageProvider } from "./context/ImageContext"; // Import provider

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ImageProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ImageProvider>
    </AuthProvider>
  </React.StrictMode>
);
